/**
 * API origin for fetch/axios. In local CRA dev, use '' so package.json "proxy"
 * sends /api and /auth to :3002 same-origin — session cookies work for localhost and 127.0.0.1.
 */
export function getApiBase() {
  if (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) {
    return String(process.env.REACT_APP_API_URL).replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    const hostname = window.location?.hostname || '';
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return '';
    }
  }
  return '';
}
